<nav class="bg-white border-b border-gray-100 fixed w-full z-50 top-0 start-0">
  <div class="flex flex-wrap items-center justify-between mx-auto p-4">
    <a routerLink="/" class="flex items-center space-x-3 rtl:space-x-reverse gap-2">
      <img src="assets/images/logo.png" class="mx-auto h-8" alt="AOC Logo" />

      <span class="self-center text-2xl font-semibold whitespace-nowrap text-text-main">
        AOC {{ isSubAdmin() ? 'Sub Admin' : 'Admin' }}
      </span>
    </a>
    <div class="flex md:order-2 gap-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
      @if(!isSubAdmin()) {
      <div
        class="py-1.5 px-3 md:px-4 font-medium text-dark bg-primary rounded-full flex items-center gap-2 hover:shadow-lg transition duration-300">
        <!-- Gradient Circle Icon -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="url(#goldGradient)"
          class="w-5 h-5 hidden sm:block">
          <defs>
            <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#FFD700;" />
              <stop offset="100%" style="stop-color:#FFECB3;" />
            </linearGradient>
          </defs>
          <circle cx="12" cy="12" r="10" stroke="#B8860B" stroke-width="1.5" fill="url(#goldGradient)" />
        </svg>
        <!-- Wallet address -->
        <span class="text-xs md:text-sm font-bold tracking-tight">{{connectedWalletAddress().slice(0,
          6)+'...'+connectedWalletAddress().slice(-4)}}</span>

        <!-- Copy Button -->
        <button (click)="copyAddress()" class="p-1.5 hover:bg-white/20 rounded-lg transition-colors group/copy relative"
          title="Copy Address">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-text-main" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
              d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
        </button>
      </div>
      }

      <div class="relative">
        <button (click)="toggleProfile()"
          class="flex items-center gap-3 rounded-full border border-gray-200 bg-white px-4 py-2 shadow-sm hover:shadow-md transition">
          <div class="h-9 w-9 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 text-primary ring-2 ring-white flex items-center justify-center text-[11px] font-extrabold">
            {{ profileInitials() }}
          </div>
          <span class="hidden sm:flex min-w-0 flex-col items-start leading-tight">
            <span class="text-sm font-semibold text-text-main truncate max-w-[220px]">{{ profileName() }}</span>
            @if (profileEmail()) {
            <span class="text-[11px] text-text-muted truncate max-w-[220px]">{{ profileEmail() }}</span>
            }
          </span>
        </button>

        @if (isProfileOpen()) {
        <div
          class="absolute right-0 mt-3 w-72 rounded-3xl border border-gray-100 bg-white p-4 shadow-[0_20px_60px_rgba(15,23,42,0.18)]">
          <div class="flex items-center gap-3">
            <div class="h-11 w-11 rounded-2xl bg-gradient-to-br from-primary/25 to-primary/5 text-primary ring-2 ring-white flex items-center justify-center text-sm font-extrabold">
              {{ isEditingProfile() ? draftProfileInitials() : profileInitials() }}
            </div>
            <div class="min-w-0">
              <p class="text-sm font-semibold text-text-main truncate">{{ isEditingProfile() ? draftProfileName() : profileName() }}</p>
              @if (profileEmail()) {
              <p class="text-xs text-text-muted truncate">{{ profileEmail() }}</p>
              }
              <!-- <p class="text-xs text-text-muted">{{ profileRoleLabel() }}</p> -->
            </div>
          </div>

          <div class="mt-4 rounded-2xl border border-gray-100 bg-gray-50 p-3">
            <div class="flex items-center justify-between">
              <span class="text-[11px] font-bold text-text-muted uppercase tracking-wide">Display Name</span>
              @if (!isEditingProfile()) {
              <button (click)="startEditProfile()" [disabled]="isSavingProfileName()"
                class="text-xs font-bold text-primary hover:opacity-80 disabled:opacity-50">
                Edit
              </button>
              } @else {
              <button (click)="saveProfileName()" [disabled]="isSavingProfileName()"
                class="text-xs font-bold text-primary hover:opacity-80 disabled:opacity-50">
                Save
              </button>
              }
            </div>

            <div class="mt-2">
              <input
                class="w-full rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-text-main focus:outline-none focus:ring-2 focus:ring-primary/25 disabled:bg-gray-50"
                [value]="isEditingProfile() ? draftProfileName() : profileName()"
                (input)="onProfileNameInput($event)"
                [readonly]="!isEditingProfile() || isSavingProfileName()"
                [disabled]="isSavingProfileName()" />
            </div>
            <p class="mt-2 text-[11px] text-text-muted">Visible only to you.</p>
          </div>
        </div>
        }
      </div>

      <!-- Logout Button -->
      <button (click)="logout()"
        class="hidden md:flex items-center gap-2 px-4 py-2 text-sm font-bold text-red-500 hover:text-red-600 hover:bg-red-50 rounded-xl transition-all duration-300 group">
        <svg xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 group-hover:transform group-hover:translate-x-1 transition-transform" fill="none"
          viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        Sign Out
      </button>

      <!-- Mobile Logout Button -->
      <button (click)="logout()"
        class="md:hidden inline-flex items-center gap-2 px-3 py-2 text-sm font-bold text-red-500 hover:text-red-600 hover:bg-red-50 rounded-xl transition-all duration-300">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        Sign Out
      </button>

      <button (click)="toggleMenu()" type="button"
        class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
        aria-controls="navbar-sticky" [attr.aria-expanded]="isMenuOpen()">
        <span class="sr-only">Open main menu</span>
        @if (!isMenuOpen()) {
        <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M1 1h15M1 7h15M1 13h15" />
        </svg>
        } @else {
        <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
        }
      </button>
    </div>
    <!-- <div [class.hidden]="!isMenuOpen()" class="items-center justify-between w-full md:flex md:w-auto md:order-1" id="navbar-sticky">
      <ul class="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white">
        @for (item of navItems; track item.path) {
          <li>
            <a [routerLink]="item.path" 
               routerLinkActive="text-primary"
               [routerLinkActiveOptions]="{exact: true}"
               class="block py-2 px-3 text-text-main rounded-sm hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary md:p-0 transition-colors duration-200" 
               aria-current="page">{{ item.label }}</a>
          </li>
        }
      </ul>
    </div> -->
  </div>
</nav>
